var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_9068127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.25 21.917C5.28535 21.917 1.25 17.8816 1.25 12.917C1.25 7.95234 5.28535 3.91699 10.25 3.91699C15.2147 3.91699 19.25 7.95234 19.25 12.917C19.25 17.8816 15.2147 21.917 10.25 21.917ZM10.25 5.17281C5.98023 5.17281 2.50581 8.64722 2.50581 12.917C2.50581 17.1868 5.98023 20.6612 10.25 20.6612C14.5198 20.6612 17.9942 17.1868 17.9942 12.917C17.9942 8.64722 14.5198 5.17281 10.25 5.17281Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.25 14.3822C9.90672 14.3822 9.62207 14.0975 9.62207 13.7543V9.56821C9.62207 9.22496 9.90672 8.94031 10.25 8.94031C10.5932 8.94031 10.8779 9.22496 10.8779 9.56821V13.7543C10.8779 14.0975 10.5932 14.3822 10.25 14.3822Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.2498 17.1037C10.141 17.1037 10.0321 17.0786 9.93167 17.0367C9.8312 16.9949 9.73911 16.9363 9.65539 16.8609C9.58004 16.7772 9.52143 16.6935 9.47957 16.5846C9.43771 16.4842 9.4126 16.3753 9.4126 16.2665C9.4126 16.1577 9.43771 16.0488 9.47957 15.9484C9.52143 15.8479 9.58004 15.7558 9.65539 15.6721C9.73911 15.5967 9.8312 15.5381 9.93167 15.4963C10.1326 15.4125 10.367 15.4125 10.5679 15.4963C10.6684 15.5381 10.7605 15.5967 10.8442 15.6721C10.9196 15.7558 10.9782 15.8479 11.02 15.9484C11.0619 16.0488 11.087 16.1577 11.087 16.2665C11.087 16.3753 11.0619 16.4842 11.02 16.5846C10.9782 16.6935 10.9196 16.7772 10.8442 16.8609C10.7605 16.9363 10.6684 16.9949 10.5679 17.0367C10.4675 17.0786 10.3586 17.1037 10.2498 17.1037Z",
    fill: "#A1A1A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8298016db8a576bb6c6e89774f191067.svg";
export { ForwardRef as ReactComponent };